import { ApiCall, ParameterTypes } from '@lcms/api-definition';
import endpoints from '../api-endpoint-definition.json';
import { ApiResponse } from './api-response';

const definition = new ApiCall<ApiResponse>().post('setTrendingResourceSticky', { 
    route: endpoints.adminTrendingResourcesSticky,
    params: {
        id: {
            type: ParameterTypes.String
        },
        sticky: {
            type: ParameterTypes.Boolean
        }
    }
})
export default definition;